export const normalizeTaDeskDomain = (input?: string): string => {
  if (!input) {
    return "";
  }
  return input
    .trim()
    .toLowerCase()
    .replace(/^https?:\/\//, "")
    .replace(/\/.*$/, "")
    .replace(/\.tadesk\.app$/i, "");
};

export const encodeTaDeskPortalValue = (value: string): string => {
  return value
    .replace(/!/g, "!!")
    .replace(/[():,]/g, (ch) => `!${ch}`)
    .replace(/\+/g, "!+")
    .replace(/@/g, "%40")
    .replace(/ /g, "%20")
    .replace(/&/g, "%26")
    .replace(/#/g, "%23")
    .replace(/\?/g, "%3F");
};

export const buildTaDeskQuoteUrl = ({
  domain,
  firstName,
  lastName,
  primaryEmail,
  primaryMobile,
  ccConversationId,
}: {
  domain?: string;
  firstName?: string;
  lastName?: string;
  primaryEmail?: string;
  primaryMobile?: string;
  ccConversationId?: string;
}): string | null => {
  const subdomain = normalizeTaDeskDomain(domain);
  if (!subdomain) {
    return null;
  }

  const portalFields: string[] = ["name:quick-add-quote", "visible:true"];

  if (firstName) {
    portalFields.push(`firstName:${encodeTaDeskPortalValue(firstName)}`);
  }
  if (lastName) {
    portalFields.push(`lastName:${encodeTaDeskPortalValue(lastName)}`);
  }
  if (primaryEmail) {
    portalFields.push(`primaryEmail:${encodeTaDeskPortalValue(primaryEmail)}`);
  }
  if (primaryMobile) {
    portalFields.push(
      `primaryMobile:${encodeTaDeskPortalValue(primaryMobile)}`,
    );
  }
  if (ccConversationId) {
    portalFields.push(
      `ccConversationId:${encodeTaDeskPortalValue(ccConversationId)}`,
    );
  }

  return `https://${subdomain}.tadesk.app/dashboard?portals=((${portalFields.join(
    ",",
  )}))`;
};

export const buildTaDeskEnquiryUrl = ({
  domain,
  enquiryId,
}: {
  domain?: string;
  enquiryId: string;
}): string | null => {
  const subdomain = normalizeTaDeskDomain(domain);
  if (!subdomain || !enquiryId) {
    return null;
  }
  return `https://${subdomain}.tadesk.app/dashboard?portals=((name:view-enquiry,visible:true,enquiryId:${enquiryId}))`;
};

export const buildTaDeskQuotePreviewUrl = ({
  domain,
  holidayQuoteId,
}: {
  domain?: string;
  holidayQuoteId: string;
}): string | null => {
  const subdomain = normalizeTaDeskDomain(domain);
  if (!subdomain || !holidayQuoteId) {
    return null;
  }
  return `https://${subdomain}.tadesk.app/dashboard?portals=((name:holiday-quote-preview,visible:true,holidayQuoteId:${holidayQuoteId}))`;
};
